/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface SlackChannel2
 */
export interface SlackChannel2 {
    /**
     * 
     * @type {string}
     * @memberof SlackChannel2
     */
    channelId: string;
    /**
     * 
     * @type {string}
     * @memberof SlackChannel2
     */
    channelName: string;
    /**
     * 
     * @type {boolean}
     * @memberof SlackChannel2
     */
    isPrivate: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SlackChannel2
     */
    isMember: boolean;
}

export function SlackChannel2FromJSON(json: any): SlackChannel2 {
    return {
        'channelId': json['channelId'],
        'channelName': json['channelName'],
        'isPrivate': json['isPrivate'],
        'isMember': json['isMember'],
    };
}

export function SlackChannel2ToJSON(value?: SlackChannel2): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'channelId': value.channelId,
        'channelName': value.channelName,
        'isPrivate': value.isPrivate,
        'isMember': value.isMember,
    };
}


